import 'slick-carousel';

// import cookieConsent from './cookieConsent';
import videolink from './videolink';
import header from './header';
import clubs from './clubs';
import startTimer from './startTimer';
import translate from './translate';
import * as slickGallery from './slick-gallery';
import slickMediaGallery from './slick-media-gallery';
import listenForClicks from './calendar';
import newsApi from './news-from-category';
import beachesPagePart from './beach-pagepart';
import videoToggler from './video';
import { changeFontSize, setContrast } from './dis';
import form from './forms';

global.jQuery = require('jquery');
import '../../../vendor/jamel/images-lazy-load-bundle/Resources/public/js/images-lazy-load-bundle.min';

document.addEventListener('DOMContentLoaded', () => {
    // cookieConsent();
    videolink();
    header();
    clubs();
    translate();
    slickMediaGallery('.gallery');
    form();

    // homepage
    slickGallery.mainSlider();
    slickGallery.latestEvents();
    slickGallery.objects();
    slickGallery.projects();

    // events page
    listenForClicks();

    videoToggler();

    changeFontSize();
    setContrast();

    // news-from-category ajax
    newsApi();

    beachesPagePart();

    if (document.querySelector('#counter-block')) {
        startTimer(document.querySelector('#counter-block'));
    }
});
